import styled from "styled-components";

import { theme } from "../../styles/theme";

export const Container = styled.div`
  height: 5em;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 15px;
  position: relative;

  @media screen and (max-width: 768px) {
    position: sticky;
  }

  font-family: ${theme.font.roboto};
`;

export const Logo = styled.img`
  object-fit: contain;
  cursor: pointer;
`;

export const DropDown = styled.div`
  display: flex;
  justify-content: flex-start;
  max-width: 200px;
  flex-direction: column;
  background-color: ${theme.colors.darkBlue};
  color: ${theme.colors.white};
  right: 27px;
  border-radius: 15px;
  position: absolute;
  width: 100%;
  padding: 15px 0px;
  top: 84%;
  z-index: 1;
`;

interface IDropDownOptionProps {
  show: boolean;
}

export const DropDownOption = styled.div<IDropDownOptionProps>`
  justify-content: flex-start;
  padding: 7px 30px;
  font-size: 14px;
  cursor: pointer;
  transition: ease all 300ms;
  display: ${({ show }) => (show ? "flex" : "none")};

  &:hover {
    background-color: ${theme.colors.lightBlue};
  }

  svg {
    margin-right: 5px;
  }
`;

export const Items = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
  margin-right: 15px;
  position: relative;

  button {
    color: ${theme.colors.white};
    font-weight: ${theme.font.normal};
    font-size: ${theme.font.sizes.xxxsmall};
    font-family: ${theme.font.roboto};
    background-color: transparent;
    cursor: pointer;

    svg[aria-label="arrow-down"] {
      width: 10px;
      height: 10px;
      margin-left: 10px;
      cursor: pointer;

      path {
        fill: ${theme.colors.white};
      }
    }
  }

  svg[aria-label="menu-icon"] {
    cursor: pointer;

    path {
      fill: ${theme.colors.white};
    }

    @media (min-width: 768px) {
      display: none;
    }
  }
`;

export const IconContainer = styled.div`
  background-color: ${theme.colors.blue100};
  border-radius: 50%;
  width: 34px;
  height: 34px;
  justify-content: center;
  align-items: center;
  display: flex;

  svg {
    path {
      fill: ${theme.colors.blue400};
    }
  }
`;
